<template>
  <div class="demo-page">
    <h1>知识课程展示组件演示</h1>
    
    <div class="demo-links">
      <router-link to="/knowledge/courses" class="demo-link">
        <div class="link-card">
          <h3>课程管理页面</h3>
          <p>包含管理视图和学习视图的切换</p>
        </div>
      </router-link>
      
      <router-link to="/knowledge/courses/display" class="demo-link">
        <div class="link-card">
          <h3>独立展示页面</h3>
          <p>纯展示模式，树形结构展示课程和知识点</p>
        </div>
      </router-link>
    </div>
    
    <div class="demo-info">
      <h2>功能说明</h2>
      <ul>
        <li><strong>课程树形展示：</strong>左侧显示所有课程，点击课程展开知识点树</li>
        <li><strong>知识点内容：</strong>右侧显示选中知识点的详细内容</li>
        <li><strong>查找功能：</strong>支持按课程名称和分类查找</li>
        <li><strong>响应式设计：</strong>支持移动端和桌面端</li>
        <li><strong>层级结构：</strong>支持多层级知识点展示</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeDemo'
}
</script>

<style scoped>
.demo-page {
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
}

.demo-page h1 {
  text-align: center;
  color: #333;
  margin-bottom: 40px;
}

.demo-links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;
}

.demo-link {
  text-decoration: none;
  color: inherit;
}

.link-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.link-card:hover {
  border-color: #2196F3;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
  transform: translateY(-2px);
}

.link-card h3 {
  color: #2196F3;
  margin: 0 0 10px 0;
}

.link-card p {
  color: #666;
  margin: 0;
}

.demo-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
}

.demo-info h2 {
  color: #333;
  margin: 0 0 15px 0;
}

.demo-info ul {
  margin: 0;
  padding-left: 20px;
}

.demo-info li {
  color: #555;
  line-height: 1.6;
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .demo-links {
    grid-template-columns: 1fr;
  }
  
  .demo-page {
    padding: 20px;
  }
}
</style> 